// extracted by mini-css-extract-plugin
export var clinicDetails = "styles-module--clinicDetails--5N+gV";
export var clinicInfo = "styles-module--clinicInfo--eveJ0";
export var content = "styles-module--content--xbBcZ";
export var directionsCta = "styles-module--directionsCta--iuX3I";
export var disclaimer = "styles-module--disclaimer--edIry";
export var hoursCol = "styles-module--hoursCol--yIwQ8";
export var hoursOfOperation = "styles-module--hoursOfOperation--TxR64";
export var hoursWrapper = "styles-module--hoursWrapper--mwXYP";